import { FontColors, FontFamilies, FontWeights, Fonts } from "./fontConfig";

// Same breakpoints as the MUI default theme, so responsive sizes match `sx`.
const BREAKPOINTS = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 };

const kebab = (name) => name.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const cssSize = (size) => (typeof size === "number" ? `${size}px` : size);

export function buildFontVariablesCss() {
  const root = [];
  const media = {};

  Object.entries(FontFamilies).forEach(([name, family]) => {
    root.push(`--${kebab(name)}-font-family: ${family};`);
  });
  Object.entries(FontWeights).forEach(([name, weight]) => {
    root.push(`--font-weight-${kebab(name)}: ${weight};`);
  });
  Object.entries(FontColors).forEach(([name, color]) => {
    root.push(`--font-color-${name.toLowerCase()}: ${color};`);
  });
  Object.entries(Fonts).forEach(([name, font]) => {
    const prefix = `--${kebab(name)}`;
    root.push(`${prefix}-family: ${font.fontFamily};`);
    root.push(`${prefix}-weight: ${font.fontWeight};`);
    if (font.fontSize && typeof font.fontSize === "object") {
      Object.entries(font.fontSize).forEach(([breakpoint, size]) => {
        const minWidth = BREAKPOINTS[breakpoint];
        if (minWidth === 0) root.push(`${prefix}-size: ${cssSize(size)};`);
        else (media[minWidth] = media[minWidth] || []).push(`${prefix}-size: ${cssSize(size)};`);
      });
    } else {
      root.push(`${prefix}-size: ${cssSize(font.fontSize)};`);
    }
  });

  const mediaCss = Object.keys(media)
    .sort((a, b) => a - b)
    .map((minWidth) => `@media (min-width: ${minWidth}px) { :root { ${media[minWidth].join(" ")} } }`);
  return [`:root { ${root.join(" ")} }`, ...mediaCss].join("\n");
}

export function injectFontVariables() {
  const id = "font-variables";
  let style = document.getElementById(id);
  if (!style) {
    style = document.createElement("style");
    style.id = id;
    document.head.prepend(style);
  }
  style.textContent = buildFontVariablesCss();
}
